import template from './sftp-list.html';

import { initGrid } from 'utils/grid/grid';
import { fetchSftpList, deleteSftpById } from 'report-subscriptions/actions/sftp.actions';

const mapStateToThis = ({ sftp, config, ui }) => {
  const { list, isLoading } = sftp;
  const { sortColumnKey } = config;
  const { pagination } = ui;

  return {
    list,
    isLoading,
    sortColumnKey,
    pagination,
  };
};

const mapDispatchToThis = {
  fetchSftpList,
  deleteSftpById,
};
@Inject('$ngRedux', 'gettextCatalog', '$state', 'Notifications')
class SftpListController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.headers = this.listHeaders();
    this.defaultParams = {
      [this.sortColumnKey]: 'retailerId',
    };

    this.gridModel = initGrid(this.fetchSftpList, this.defaultParams);
    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  search() {
    this.gridModel.applyFilters();
  }

  async onSftpConfigurationRemove(id) {
    await this.deleteSftpById(id);

    this.Notifications.alertSuccess(this.gettextCatalog.getString('Configuration has been removed'));
    this.search();
  }

  listHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Retailer ID'),
        field: 'retailerId',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Retailer Name'),
        field: 'retailerName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Host Address'),
        field: 'ftpHost',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Use SFTP Public Key'),
      },
      {
        text: this.gettextCatalog.getString('Enabled'),
      },
      {
        text: this.gettextCatalog.getString('Delete Configuration'),
        textAlignment: 'text-right',
      },
    ];
  }
}

export default class SftpListComponent {
  constructor() {
    this.template = template;
    this.controller = SftpListController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/components/management/sftp/sftp-list/sftp-list-component.js